import { Component, OnInit, Input, EventEmitter, AfterViewInit } from '@angular/core';
import { GridHeader } from '../grid.model';
import { DialogControl } from '../../dialog/dialog.model';

@Component({
  selector: 'app-column-editor',
  templateUrl: './column-editor.component.html',
  styleUrls: ['./column-editor.component.scss']
})
export class ColumnEditorComponent implements OnInit, AfterViewInit, DialogControl {
  
  public dialogConfigData: any;
  public onDialogClose: EventEmitter<any> = new EventEmitter<any>();
  isConfirmButtonDisabled: boolean = false;

  private items: GridHeader[];

  constructor() { }

  ngOnInit() {
    this.processDialogConfig();
  }

  ngAfterViewInit() {
  }

  public closeDialog() {
    this.onDialogClose.emit();
  }

  public confirmDialog() {
    if(!this.items.some(item => item.isVisible)) {
      sweetAlert("Przynajmniej 1 kolumna musi być widoczna.");
      return;
    }

    let visibleItems = [];
    let columnSettings = {};
    for (let index = 0; index < this.items.length; index++) {
      const item = this.items[index];
      if(item.isVisible == true) {
        visibleItems.push(item);
      }
      columnSettings[item.propertyName] = {index: index, isVisible: item.isVisible};
    }

    this.onDialogClose.emit({visibleItems: visibleItems, columnSettings: columnSettings});
  }

  private processDialogConfig() {
    if(!this.dialogConfigData){
      return;
    }

    if (this.dialogConfigData['items']) {
      this.items = this.dialogConfigData['items'];
    }
  }

}
